import { Dispatch } from "redux";
import { baseAction } from "./baseAction";
import { leadStatusConstant, loaderConstant } from "../constants";
import {
  getLeadStatuses,
  createLeadStatus,
  updateLeadStatus,
  deleteLeadStatus,
  updateLeadStatusSortOrders,
  type LeadStatusCreate,
  type LeadStatusUpdate,
} from "../../services/leadStatusService";

const { request, success, failure } = baseAction;

// Get lead statuses for agency
const getLeadStatusesAction = (cb: (data?: any) => void = () => {}) => {
  return (dispatch: Dispatch) => {
    dispatch(request(leadStatusConstant.GET_LEAD_STATUSES_R, {}));
    dispatch(request(loaderConstant.LOADING_TRUE, {}));

    getLeadStatuses()
      .then((statuses) => {
        dispatch(
          success(leadStatusConstant.GET_LEAD_STATUSES_S, {
            data: { statuses },
          })
        );
        dispatch(request(loaderConstant.LOADING_FALSE, {}));
        cb({ data: { statuses } });
      })
      .catch((error) => {
        dispatch(failure(leadStatusConstant.GET_LEAD_STATUSES_F, error));
        dispatch(request(loaderConstant.LOADING_FALSE, {}));
      });
  };
};

// Create lead status
const createLeadStatusAction = (
  data: LeadStatusCreate,
  cb: (data?: any) => void = () => {}
) => {
  return (dispatch: Dispatch) => {
    dispatch(request(leadStatusConstant.CREATE_LEAD_STATUS_R, data));

    createLeadStatus(data)
      .then((status) => {
        dispatch(
          success(leadStatusConstant.CREATE_LEAD_STATUS_S, {
            data: { status },
          })
        );
        cb({ data: { status } });
      })
      .catch((error) => {
        dispatch(failure(leadStatusConstant.CREATE_LEAD_STATUS_F, error));
      });
  };
};

// Update lead status
const updateLeadStatusAction = (
  statusName: string,
  updates: LeadStatusUpdate,
  cb: (data?: any) => void = () => {}
) => {
  return (dispatch: Dispatch) => {
    dispatch(request(leadStatusConstant.UPDATE_LEAD_STATUS_R, { statusName, updates }));

    updateLeadStatus(statusName, updates)
      .then((status) => {
        dispatch(
          success(leadStatusConstant.UPDATE_LEAD_STATUS_S, {
            data: { status },
          })
        );
        cb({ data: { status } });
      })
      .catch((error) => {
        dispatch(failure(leadStatusConstant.UPDATE_LEAD_STATUS_F, error));
      });
  };
};

// Delete lead status
const deleteLeadStatusAction = (
  statusName: string,
  cb: (data?: any) => void = () => {}
) => {
  return (dispatch: Dispatch) => {
    dispatch(request(leadStatusConstant.DELETE_LEAD_STATUS_R, { statusName }));

    deleteLeadStatus(statusName)
      .then(() => {
        dispatch(
          success(leadStatusConstant.DELETE_LEAD_STATUS_S, { statusName })
        );
        cb();
      })
      .catch((error) => {
        dispatch(failure(leadStatusConstant.DELETE_LEAD_STATUS_F, error));
      });
  };
};

// Update lead status sort orders
const updateLeadStatusSortOrdersAction = (
  sortOrders: Record<string, number>,
  cb: (data?: any) => void = () => {}
) => {
  return (dispatch: Dispatch) => {
    // Don't dispatch request action to avoid loading state
    updateLeadStatusSortOrders(sortOrders)
      .then((statuses) => {
        dispatch(
          success(leadStatusConstant.GET_LEAD_STATUSES_S, {
            data: { statuses },
          })
        );
        cb({ data: { statuses } });
      })
      .catch((error) => {
        dispatch(failure(leadStatusConstant.UPDATE_LEAD_STATUS_F, error));
      });
  };
};

export const leadStatusAction = {
  getLeadStatuses: getLeadStatusesAction,
  createLeadStatus: createLeadStatusAction,
  updateLeadStatus: updateLeadStatusAction,
  deleteLeadStatus: deleteLeadStatusAction,
  updateLeadStatusSortOrders: updateLeadStatusSortOrdersAction,
};

